import { render, staticRenderFns } from "./AffirmBookAuthor.vue?vue&type=template&id=7d857d52&"
import script from "./AffirmBookAuthor.vue?vue&type=script&lang=js&"
export * from "./AffirmBookAuthor.vue?vue&type=script&lang=js&"
import style0 from "./AffirmBookAuthor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports